import { render } from "./IconForkLift.vue?vue&type=template&id=63df9dd0"
import script from "./IconForkLift.vue?vue&type=script&lang=ts"
export * from "./IconForkLift.vue?vue&type=script&lang=ts"
script.render = render

export default script